<div class="payment-recurrence-row">
  <div class="payment-recurrence-tabs">
    <button
      type="button"
      class="tab-button"
      [ngClass]="{ 'active': payRecurrence === 'month' }"
      (click)="onRecurrenceClick('month')"
      [trackClick]="{ page: 'Selected Plan Terms', terms: 'Pay Monthly' }"
    >
      {{ 'billing.monthly' | translate }}
    </button>

    <button
      type="button"
      class="tab-button"
      [ngClass]="{ 'active': payRecurrence === 'year' }"
      (click)="onRecurrenceClick('year')"
      [trackClick]="{ page: 'Selected Plan Terms', terms: 'Pay Annually' }"
    >
      {{ 'billing.yearlySaves17' | translate }}
    </button>
  </div>

  <app-billing-calculator *ngIf="showCalculator && !hideCalculator" (usersChange)="onUsersChange($event)"></app-billing-calculator>
</div>
